module.exports = __webpack_public_path__ + "img/am04.d4ddac82.jpg";